import Api from './api.service';

export default {
  destroy: (id) => Api.delete(`user-roles/${id}`),
  get: (params = {}) => Api.get('user-roles', { params }),
  permissions: (params = {}) => Api.get('user-roles/permissions', { params }),
  put: (data, id) => Api.put(`user-roles/${id}`, data),
  store: (data) => Api.post('user-roles', data),
};
